/* istanbul ignore file */
import React from 'react';
import { EditTimelineRecordButton, FlagAsInappropriateTimelineRecordButton } from 'domain/shared/timeline/button';
import { HtmlField } from 'framework/ui/field';
import { TimelineCollapsible } from 'framework/ui/timeline';
import FeedbackOnBehalf from 'domain/people/employee/Timeline/feedback/shared/layout/FeedbackOnBehalf';
import FeedbackFooter from 'domain/people/employee/Timeline/feedback/shared/layout/FeedbackFooter';
import { UPDATE_EMPLOYEE_FEEDBACK } from 'domain/people/employee/Timeline/feedback/employeeFeedbackService';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import { useShowContext } from 'framework/show';
import BasePersonTimelineRecordLayout from 'domain/shared/timeline/person/PersonTimelineRecord/BasePersonTimelineRecordLayout';
import PersonTimelineRecordHeader from 'domain/shared/timeline/person/PersonTimelineRecord/PersonTimelineRecordHeader';
import EditNote from '@mui/icons-material/EditNote';
import Feedback from '@mui/icons-material/Feedback';
import FeedbackFlagAsInappropriateButton from 'domain/people/employee/Timeline/feedback/shared/button/FeedbackFlagAsInappropriateButton';
import useEmployeeTimelinePinAction from 'domain/people/employee/Timeline/shared/useEmployeeTimelinePinAction';
import type { BasePersonTimelineRecordLayoutProps } from 'domain/shared/timeline/person';
import { FeedbackOnBehalfProps } from '../../../types';

interface EmployeeFeedbackTimelineRecordLayoutProps extends Partial<BasePersonTimelineRecordLayoutProps> {
  onEdit: () => void;
  isPinned?: boolean;
}

const EmployeeFeedbackTimelineRecordLayout = ({
  onEdit,
  isPinned,
  ...props
}: EmployeeFeedbackTimelineRecordLayoutProps) => {
  const { data: entity } = useShowContext();
  const pinActions = useEmployeeTimelinePinAction({ isPinned: !!isPinned, key: 'feedBackPin' });

  const feedbackText = entity?.getValueBySource('feedbackText');

  const buttons = [
    <EditTimelineRecordButton permissionToCheck={UPDATE_EMPLOYEE_FEEDBACK} key="edit" onEdit={onEdit} />,
    <FlagAsInappropriateTimelineRecordButton key="flag" FeedbackButton={FeedbackFlagAsInappropriateButton} />,
  ];

  // Define employee timeline icons
  const EMPLOYEE_TIMELINE_ICONS: Record<string, React.ComponentType<any>> = {
    [TimelineType.NOTE]: EditNote,
    [TimelineType.FEEDBACK]: Feedback,
    default: EditNote,
  };

  return (
    <BasePersonTimelineRecordLayout
      actions={pinActions}
      timelineType={TimelineType.FEEDBACK}
      buttons={buttons}
      timelineIcons={EMPLOYEE_TIMELINE_ICONS}
      permissionToCheck={null}
      messageContext=""
      fields={
        feedbackText ? (
          <TimelineCollapsible>
            <HtmlField source="feedbackText" label="" />
          </TimelineCollapsible>
        ) : null
      }
      actionName=""
      timelineHeader={rest => (
        <PersonTimelineRecordHeader
          {...rest}
          actionName={(behalfProps: FeedbackOnBehalfProps) => <FeedbackOnBehalf {...behalfProps} />}
        />
      )}
      timelineFooter={rest => <FeedbackFooter {...rest} />}
      isCandidateService={false}
      {...props}
    />
  );
};

export default EmployeeFeedbackTimelineRecordLayout;
